import React from 'react';
import cn from 'classnames';

import CurrencySign from 'components/price/CurrencySign.component';
import { DEPOSIT_TYPE_TRANSLATION_KEYS } from 'constants/depositType.const';
import { useGilt, useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './CashupTableRow.module.scss'; // common for deposit, cash and voucher tabs

const DEFAULT_SOURCE_TYPE_NAME = 'cashUp.cashupLogs.depositItems.unknownSource';

const DepositLogItem = ({ deposit }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const { formatDate } = useGilt();

  const { source, amount, created_at, depositType, user_name } = deposit ?? {};
  const displayTime = formatDate(created_at, { hideDate: true });
  const displayDate = formatDate(created_at, { hideTime: true, hideWeekday: true });

  return (
    <div
      data-bem="DepositLogItem"
      className={cn({
        [CN.tableRow]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.fixedColumnCell}>
        <span>{displayTime} </span>
        <span>{displayDate}</span>
      </div>

      <div className={CN.cell}>
        <span> {user_name}</span>
      </div>
      <div className={CN.cell}>
        <span>
          <CurrencySign value={amount} />
        </span>
      </div>
      <div className={CN.cell}>
        <span>{t(DEPOSIT_TYPE_TRANSLATION_KEYS[source]) || t(DEFAULT_SOURCE_TYPE_NAME)}</span>
      </div>
      <div className={CN.cell}>
        <span>{depositType}</span>
      </div>
    </div>
  );
};

export default DepositLogItem;
